<template>
  <div class="pk-ea__page-wrapper">
    <div class="pk-ea-page"
     :style="pageWidth">
      <div class="pk-page-spacing-flex"></div>
      <div class="pk-ea-main-left">
        <div class="pk-ea-slideshow-wrapper">
          <slideshow-view :imageItems="slideshowImages"></slideshow-view>
        </div>
        <div class="pk-ea-introduction-wrapper">
          <div class="pk-panel-title pk-flex__00auto pk-flex__vh-center">eLaterna Archive: editions of works in the historical art of projection</div>
          <div class="pk-flex__1"
           style="position:relative">
            <div class="pk-panel-body">
              <div style="column-count: 3" v-html="infoText">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pk-page-spacing-flex"></div>
      <div class="pk-ea-main-right">
        <div class="pk-ea-month">
          <div class="pk-panel-title pk-flex__00auto pk-flex__vh-center">Slide set of the month</div>
          <div class="pk-panel-body pk-flex__1">
            <div class="pk-flex__1">
              <img class="" @click="clickMonthSlidesetImg"
               :src="getMonthSlidesetImg()">
            </div>
            <div style="text-align: center;padding:10px" v-html="getMonthSlidesetComment()"></div>
          </div>
        </div>
        <div class="pk-ea-news pk-flex--column">
          <div class="pk-panel-title pk-flex__00auto pk-flex__vh-center"> News</div>
          <div class="pk-panel-body pk-flex__1">
            <ul class="pk-ea-news-list">
              <li v-for="(n,i) of allNews" :key="i" v-html="n"></li>
            </ul>
          </div>
        </div>
      </div>
      <div style="width:10%"></div>
    </div>
  </div>

</template>

<script>
import Carousel from './Carousel.vue';
import { FudapiService } from '../../utils/fudapi.service';
import Util from '../../utils/util';

import Vue from 'vue';
export default Vue.extend({
  components: {
    'slideshow-view': Carousel
  },
  data() {
    return {
      startLoad: {
        deepestReached: false,
        threads: []
      },
      infoText: ''
    };
  },
  created() {
    this.$store.dispatch('firstRun');
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('eLaterna Archive');
    }
    Util.checkStartLoad({
      loadingCount: 0,
      startLoad: this.startLoad,
      retryCondition: () => { 
        return this.$store.state.frontText.length <= 0;
      },
      allDoneCallback: () => {
        const ftList = this.$store.state.frontText;
        for (const ft of ftList) {
          if (ft.key === 'eLaterna Archive Info') {
            const obj = {str: ft.text};
            this.startLoad.threads.push(FudapiService.transformFreetext(obj).subscribe(
              () => null,
              err => {
                console.log(err);
              },
              () => {
                this.infoText = obj.str;
              }
            ));
          }
        }
      }
    });
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  computed: {
    monthSlideset() {
      return this.$store.state.monthSlideset;
    },
    allNews() {
      return this.$store.state.allNews;
    },
    slideshowImages() {
      const images = this.$store.getters.slideshow;
      return images ? images : [];
      //        let slideset = this.monthSlideset;
      //        if(slideset && slideset.slides) {
      //          let out = [];
      //          slideset.slides.forEach(s => {
      //            s.$_images.forEach((a) => {
      //              if(a.dbImageInfo.name) {
      //                out.push(a.dbImageInfo);
      //              }
      //            })
      //          });
      //          out[0] ? (this.monthImage = out[0].small) : '';
      //          return out;
      //        }
    },
    pageWidth() {
      return 'width:80%';
    }
  },
  methods: {
    getMonthSlidesetImg() {
      if (this.monthSlideset && this.monthSlideset.slides[0] && this.monthSlideset.slides[0].getScreenImage()) {
        return this.monthSlideset.slides[0].getScreenImage().dbImageInfo.small;
      }
    },
    getMonthSlidesetComment() {
      if (this.monthSlideset) {
        return this.monthSlideset.monthSlidesetComment;
      }
    },
    clickMonthSlidesetImg() {
      if (this.monthSlideset) {
        const url = window.location.href.replace(/\/ea\/?.*/, '/ae/' + this.monthSlideset._id);
        window.open(url);
      }
    },
  }
});
</script>

<style lang="scss" scoped>

@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';


.pk-ea__page-wrapper {
  @extend .pk-flex__h-center;
  margin: 30px 0 0 0;
  height: calc(100% - 30px);
  .pk-ea-page {
    @extend .pk-flex;
    position: relative;
    overflow: auto;
  }
}

.sidebarTitle {
  color: #fff;
  height: 35px;
  background-color: rgb(173, 206, 211);
}

.sidebarBody {
  background-color: rgb(228, 239, 241);
  // overflow: auto;
}

.pk-ea-main-left {
  flex: 0 0 70%;
  position: relative;
}

.pk-ea-main-right {
  position: relative;
}

.pk-ea-slideshow-wrapper {
  position: relative;
}

.pk-ea-introduction-wrapper {
  margin-top: 30px;
  padding: 0px;
  .pk-panel-title {
    background-color: rgb(166, 184, 220);
    color: #fff;
    height: 35px;
  }
  .pk-panel-body {
    background-color: rgb(229, 232, 241);
    padding: 15px;
    font-size: 12px;
    overflow: auto;
    // width: 100%;
  }
}

.pk-ea-news {
  margin-top: 30px;
  .pk-panel-title {
    @extend .sidebarTitle;
  }
  .pk-panel-body {
    @extend .sidebarBody;
    padding: 10px;
  }
  .pk-ea-news-list {
    font-size: 13px;
    padding-left: 20px;
  }
}

.pk-ea-month {
  img {
    // padding: 10px 10px 0px 10px;
    width: 100%;
    border-radius: 15px;
    cursor: pointer;
  }
  img:hover {
    box-shadow: 0 0 15px 1px #555555;
  }
  .pk-panel-title {
    @extend .sidebarTitle;
  }
  .pk-panel-body {
    @extend .sidebarBody;
    padding: 10px;
  }
}
</style>